"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SupplierPricingConfig',
  components: {
    merchantName: _merchantName.default
  },
  data: function data() {
    return {
      merId: null,
      loading: false,
      submitLoading: false,
      configMode: 0,
      tableData: []
    };
  },
  computed: {
    hasUpdatePermission: function hasUpdatePermission() {
      var permissions = this.$store.getters && this.$store.getters.permissions;
      return permissions && (permissions.includes('*:*:*') || permissions.includes('platform:supplier:pricing:update'));
    }
  },
  mounted: function mounted() {
    var merId = this.$route.query.merId;
    if (merId) {
      this.merId = Number(merId);
      this.loadConfig();
    }
  },
  methods: {
    getMerId: function getMerId(id) {
      this.merId = id;
      if (id) {
        this.loadConfig();
      }
    },
    loadConfig: function loadConfig() {
      var _this = this;
      var resetMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.loading = true;
      (0, _product.supplierPricingConfigApi)(this.merId).then(function (res) {
        _this.tableData = res || [];
        // 仅首次加载时根据数据判断当前模式，避免覆盖用户手动切换
        if (resetMode) {
          _this.configMode = _this.tableData.some(function (item) {
            return item.configMode;
          }) ? 1 : 0;
        }
        // 初始化markupParam：如果为空则从全局档位回填
        _this.tableData.forEach(function (item) {
          if (item.markupParam === null || item.markupParam === undefined) {
            item.markupParam = 0;
          }
        });
      }).catch(function (e) {
        _this.$message.error(e.message || '加载失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    onModeChange: function onModeChange(val) {
      if (val === 1) {
        // 切换到自定义模式，重新加载数据但不重置configMode
        this.loadConfig(false);
      }
      // 切换到继承模式时，不需要重新加载，保存时清空即可
    },
    handleSave: function handleSave() {
      var _this2 = this;
      this.submitLoading = true;
      var data = {
        merId: this.merId,
        configMode: this.configMode === 1,
        items: this.configMode === 1 ? this.tableData.map(function (item) {
          return {
            debtRatio: item.debtRatio,
            markupParam: item.markupParam
          };
        }) : []
      };
      (0, _product.supplierPricingUpdateApi)(data).then(function () {
        _this2.$message.success('保存成功');
        _this2.loadConfig();
      }).catch(function (e) {
        _this2.$message.error(e.message || '保存失败');
      }).finally(function () {
        _this2.submitLoading = false;
      });
    }
  }
};